
export default class UnexpectedReponseError extends Error {
  constructor(operationId, sentryExtra) {
    const { statusCode } = sentryExtra

    let message = `Unexpected error response for ${operationId}`

    if (statusCode) {
      message += ` [${statusCode}]`
    }

    const isUnauthorized = `${statusCode}` === '401'

    if (isUnauthorized) {
      message = `Unauthorized request for ${operationId}`
    }

    const isAccessDenied = `${statusCode}` === '403'

    if (isAccessDenied) {
      message = `Access denied for ${operationId}`
    }

    super(message)

    this.code = 'UnexpectedReponseError'
    this.sentryExtra = sentryExtra
  }
}
